export default {
  logins:{
    scanLogin:"Scan to login",
    passwordLogin:"password to login",
    login:"Sign In",
    phoneNull:"Please enter your mobile number",
    phoneCheck:"Please input the correct mobile number",
    passwordNull:"lease input a password",
    passwordCheck:"Password length is more than 6 digits",
    scan:"scan",
    open:"Open",
    toLogin:"to login", 
    wechat:"wechat",
    loginAfter:"Being loaded",
    loginRefresh:"Log back in",
    noOperate:"No operational data！",
    loginSuccess:"welcome"
  },
  app: {
    search: "Search menu",
    home: "Home",
    help: "Help center",
    language: "Language",
    english: "English",
    chinese: "Chinese",
    message: "My message",
    languageTtile: "Language switch will refresh the page OK?",
    logoutTitle:"Tips",
    logoutContent:"Are you sure you want to quit?",
    personalCenter:'Personal center',
    switchRoles:'Switch roles',
    setting:'Setting',
    quit:'Quit',
  },
  personal:{
    currentIdentity:"Current identity",
    accountType:"Account type",
    modifyAvatar:"Modify",
    finish:"Finish",
    setting:"Not setting",
    accountPassword:'Account password',
    accountPasswordDec:'To protect account security, use',
    accountInfo:'Account Info',
    accountInfoDec:'Basic information of account owner',
    realName:'Real name authentication',
    realNameDec:'Used to identify the owner of account ownership to improve security',
    contactMobile:'Contact mobile phone (if the number has been changed, please modify it in time)',
    contactMobileDec:'For password retrieval and security verification',
    contactMailbox:'Contact mailbox',
    contactMailboxDec:'For password retrieval and security verification',
    bindingWeChat:'Binding WeChat',
    bindingWeChatDec:'Provide technical support and business processing progress notice',
  },
  button: {
    search: "Search",
    refresh: "Refresh",
    create: "Create",
    edit: "Detail",
    write: "Edit",
    import: "Import",
    export: "Export",
    invalid: "Invalid",
    selectTemp: "Select template",
    downloadTemp: "Download template",
    submit: "Submit",
    return: "Return",
    cancel: "Cancel",
    confirm: "Confirm",
    select: "Select",
    back: "return",
    close: "Close",
    open: "Open",
    modify: "Modify",
    setting: "Setting",
    finish:"Finish"
  },
  form:{
    status:"Status",
    select:'Select',
    englishName:'English name',
    createUser:'Founder',
    createTime:'Create time',
  },
  placeholder:{
    input:'Please input {name}',
    select:'Please choose {name}',
  },
  dialog:{
    cancel:'Cancel',
    confirm: "Confirm",
  },
  route: {
    home:"Home",   
    system:"System",
    role:"Role",
    attach:"Attach",
    operate:"Operate",
    log:"Log",
    enum:"Enum",
    power:"Power",
    module:"Module",
    user:"User",
    login:"Login",
    rootNode:"Root node",
  },
  rules:{
    required:'This field is required',
  },
  tooltip:{
    toolbarEdit:'Please select a record'
  },
  module:{
    moduleName:"Module name",
    languageKey:"Language key",
    modulePath:"Module path",
    moduleIcon:"Module icon",
    moduleNode:"Module node",
    moduleStatus:"Module status",
    pinYin:'pinYin',
    moduleStatusObj:{
      enable:'Enable',
      open:'Open',
      maintain:'Maintain',
    }
  }
}
